import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrCloseIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M13.4949 3.48526C13.7683 3.21189 13.7683 2.76868 13.4949 2.49531C13.2215 2.22194 12.7783 2.22194 12.505 2.49531L7.85445 7.14582L3.316 2.60858C3.0426 2.33525 2.59938 2.33531 2.32605 2.60871C2.05272 2.88211 2.05278 3.32533 2.32619 3.59866L6.86451 8.13577L2.49491 12.5054C2.22155 12.7787 2.22155 13.2219 2.49491 13.4953C2.76828 13.7687 3.2115 13.7687 3.48486 13.4953L7.85459 9.12559L12.1812 13.4511C12.4547 13.7244 12.8979 13.7244 13.1712 13.451C13.4445 13.1776 13.4445 12.7343 13.1711 12.461L8.84454 8.13564L13.4949 3.48526Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrCloseIconComponent;
